import React, { useEffect, useState } from 'react'
import '.././App.css';
import '.././Nav.css';
import { auth, db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import Swal from 'sweetalert2';

function Header() {


    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [status, setstatus] = useState("Active")
    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("")
    const [password, setPassword] = useState("")
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();

    const signOut = () => {
        auth.signOut();
        window.location.href = "/login";
    }


    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData2()
        });
    });

    const fetchData2 = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        if (docSnap.data().status === 'Deactive') {
                            Toast.fire({
                                icon: "error",
                                title: 'Account Not De Activated!!'
                            });

                            signOut()
                        }

                        setMobile(docSnap.data().mobile);
                        setPassword(docSnap.data().password);
                        setstatus(docSnap.data().status);
                        setName(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleUpdatePassword = async () => {
        // Check if password is long enough
        if (password.length < 6) {
            Toast.fire({
                icon: "error",
                title: 'Please fill all the fields!!'
            });
            return;
        }

        try {
            const user = auth.currentUser;
            if (user) {
                // Prompt for the user's current password to reauthenticate
                const currentPassword = prompt("Please enter your current password");

                if (!currentPassword) {
                    Toast.fire({
                        icon: "error",
                        title: 'Current password is required!'
                    });
                    return;
                }

                // Reauthenticate the user
                const credential = EmailAuthProvider.credential(user.email, currentPassword);
                await reauthenticateWithCredential(user, credential);

                // Once reauthenticated, update the password
                await updatePassword(user, password);

                // Update the password in Firestore users collection
                const userRef = doc(db, "users", userData.uid);
                await updateDoc(userRef, { password: password });


                Toast.fire({
                    icon: "success",
                    title: 'Password Updated!!'
                });

                signOut();

            }
        } catch (error) {
            console.log(error);

            // Show error message
            Toast.fire({
                icon: "error",
                title: 'Error updating password: ' + error.message
            });
        }
    };


    const [pendingCount, setpendingCount] = useState(0);


    useEffect(() => {
        fetchData1()
    }, []);

    const fetchData1 = async () => {
        const q5 = query(collection(db, 'websitebookings'), where('status', '==', 'Unpaid'));
        const snapshot5 = await getDocs(q5);
        setpendingCount(snapshot5.size);
    }


    return (
        <div>
            {/* <div className="preloader flex-column justify-content-center align-items-center">
        <img className="animation__shakesrc={window.location.origin + '/../dist/img/AdminLTELogo.png" alt="AdminLTELogo" height={60} width={60} /'}
        </div> */}

            <nav className="main-header navbar navbar-expand navbar-orange navbar-dark" style={{ backgroundColor: "rgb(1, 49, 66)" }}>
                {/* Left navbar links */}
                <ul className='navbar-nav'>
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="/#0" role="button"><i className="fas fa-bars" /></a>
                    </li>
                </ul>
                <div class="navigation ">
                    <ul className="navbar-nav">
                        <li>
                            <a href="/home">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/bookingi1251-slx-200w.png"} class="navimg"
                                    />
                                    <h6 style={{ color: "white" }}>Bookings</h6>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/room-cleaning">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/twitchi1251-nh94-200w.png"} class="navimg"
                                    />
                                    <h6 style={{ color: "white" }}>Cleaning </h6>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/checkout-history">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/rssi1251-h74v-200w.png"} class="navimg"
                                    />
                                    <h6 style={{ color: "white" }}>Checkouts</h6>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/reserve-room">
                                <img alt="img" src={window.location.origin + "/external/addi1251-wira-200h.png"} style={{
                                    height: 90, padding: 5, width: 90, marginTop: 20, backgroundColor: "rgb(1, 49, 66)" ,
                                    borderBottomLeftRadius:45, borderBottomRightRadius:45
                                }} class="navimg"
                                />

                            </a>
                        </li>
                        <li>
                            <a href="/daily-report">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/controlpaneli1251-6f1g-200w.png"} class="navimg"
                                    />
                                    <h6 style={{ color: "white" }}> Report</h6>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="/pending-bookings">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/xingi1251-2782-200w.png"} class="navimg"
                                    />

                                    <h6 style={{ color: "white" }}>Pending&nbsp;Bookings
                                        {
                                            pendingCount > 0 &&
                                            <b style={{ color: "white", fontSize: 16 }}> ({pendingCount})</b>
                                        }
                                    </h6>

                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#0" data-toggle="modal" data-target="#userupdate-modal">
                                <div className='rohanactive text-center'>
                                    <img alt="img" src={window.location.origin + "/external/iconizeri1251-xyr-200w.png"} class="navimg"
                                    />
                                    <h6 style={{ color: "white" }}>User</h6>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a className="nav-link" style={{ fontSize: 20 }} onClick={() => signOut()} href="/#0">
                            <i className="fa fa-sign-out" />
                        </a>
                    </li>
                </ul>
            </nav>


            <div className="modal fade" id="userupdate-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Update User Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" value={name} readOnly onChange={(e) => setName(e.target.value)} placeholder="Full name" required />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-user" />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" value={mobile} readOnly onChange={(e) => setMobile(e.target.value)} placeholder="Mobile No" required />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-phone" />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group mb-3">
                                    <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Password" />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-lock" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="submit" onClick={() => handleUpdatePassword()} className="btn btn-primary" >Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default Header